export default  {
    diasFaltando: {
        RENOVACAO:45
    }
}



// WEBPACK FOOTER //
// ./src/helpers/dias-faltando-liberar-renovacao-enum.js